import React, { useContext, useState } from 'react'
import { DataContext } from '../../componets/ContextProvider';
import Button from '../../componets/Button';
import "./property.css"
import Home from "../HomePage/Home"
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaBed, FaToilet } from 'react-icons/fa';
import Modal from '../../componets/Modal';

const Property = () => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [startX, setStartX] = useState(0);
  const {
    list,
    tour,
    setWhatsappMessage,
    whatsappMessage,
    openModal,
    handleSendToWhatsApp,
  } = useContext(DataContext)

  if(!list){
    return <Home />
  }

  const propertyImage = list.images

  const handleTouchStart = (event) => {
    setStartX(event.touches[0].clientX);
  };

  const handleTouchMove = (event) => {
    const currentX = event.touches[0].clientX;
    const diffX = startX - currentX;

    if (diffX > 50) {
      // Swipe left
      const newIndex = currentIndex === propertyImage.length - 1 ? 0 : currentIndex + 1;
      setCurrentIndex(newIndex);
    } else if (diffX < -50) {
      // Swipe right
      const newIndex = currentIndex === 0 ? propertyImage.length - 1 : currentIndex - 1;
      setCurrentIndex(newIndex);
    }
  };

  const increaseIndex = (e) => {
    console.log(e.target.value)
    setCurrentIndex(oldIndex => {
      return oldIndex === propertyImage.length - 1 ? 0 : currentIndex + 1
    })
  }
  const subtractIndex = () => {
    setCurrentIndex(oldIndex => {
      return oldIndex === 0 ? propertyImage.length - 1 : currentIndex -1
    })
  }

  return (
    <div>
      <h2 className="property-details-head">Property Details</h2>

      <div className="property-details-media"
       onTouchStart={handleTouchStart}
       onTouchMove={handleTouchMove}
      >
        <div className="property-details-btn">
          <Button text={<FiChevronLeft />} handleEvent={subtractIndex} aria-label="Previous Slide"/>
          <Button text={<FiChevronRight />} handleEvent={increaseIndex} aria-label="Next Slide"/>
        </div>
        <div className="property-details-img-container">
          <img src={list.images[currentIndex]} className="property-details-img" alt="property" />

          <div className="anchor">
            {list.images.map((img, index) => {
              return <span 
              key={index}
              className={index === currentIndex ? 'active-anchor' : ''}
              onClick={() => setCurrentIndex(index)}
              >.</span>
            })}
          </div>
        </div>
      </div>
                  
        <ul className="property-details-list">
          <li>&#x20A6;<b>{list.price} million</b></li>
          <li><FaBed />:{list.bedrooms}</li>
          <li><FaToilet />:{list.bathrooms}</li>
        </ul>

      <div className="property-details-info">
        <h2 className="property-details-title">{list.title.toUpperCase()}</h2>
        <p className="property-details-description">{list.description}</p>
      </div>

      <div>
        <Button 
          text={"Request for inspection"} 
          handleEvent={(e) =>tour(e,list)}
          className={"details-btn"} />
      </div>

      <div className="property-features">
        <h2 className="features-head">Features</h2>
        {list.features.map((feature, index) => {
          return <ul key={index}>
              <li>&bull; {feature}</li>
          </ul> 
        })}
      </div>

      {openModal 
        && 
        <Modal  
          text={whatsappMessage} 
          setText={setWhatsappMessage} 
          handleEvent={handleSendToWhatsApp}
        />
      }
    </div>
  )
}

export default Property
